const initialState = {
  collection: [],
  __loading: false,
  search: '',
};

const SET_SEARCH = 'SET_SEARCH';

export const setSearch = search => ({
  type: SET_SEARCH,
  search,
});

const categoryCollectionReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case '__FETCH_CATEGORY_COLLECTION':
      return {
        ...initialState,
        ...(action.payload || {}),
        __loading: true,
      };
    case '__RECEIVE_CATEGORY_COLLECTION':
      return {
        ...state,
        ...(action.payload || {}),
        __loading: false,
      };
    case '__ERROR_CATEGORY_COLLECTION':
      return {
        ...state,
        __loading: false,
      };
    case '__CLEAR_CATEGORY_COLLECTION':
      return initialState;
    case SET_SEARCH:
      return {
        ...state,
        search: action.search || '',
      };
    default:
      return state;
  }
};

export default categoryCollectionReducer;
